import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import styles from './Advantages.module.sass';
import { advantagesContent } from './Advantages.content';
import logo from './assets/logo.svg';
import cloud from '../Hero/assets/cloud-1.webp';
import cloud2 from '../Hero/assets/cloud-2.webp';

gsap.registerPlugin(ScrollTrigger);

const CLOUD_DRIFT = [
  { x: '-8vw', y: '-4vw' },
  { x: '9vw', y: '-3vw' },
  { x: '6vw', y: '4vw' },
  { x: '-7vw', y: '3vw' },
];

export function Advantages() {
  const sectionRef = useRef(null);
  const c1 = useRef(null);
  const c3 = useRef(null);
  const c4 = useRef(null);
  const c5Wrap = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const el = (r) => r.current;
    if (!el(c1) || !el(c3) || !el(c4) || !el(c5Wrap)) return;

    const isMobile =
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 900px)').matches;

    const scrollTrigger = {
      trigger: section,
      start: isMobile ? 'top bottom' : 'top 85%',
      end: isMobile ? 'bottom top' : 'bottom 15%',
      scrub: true,
      invalidateOnRefresh: true,
    };

    const animations = [
      gsap.to(el(c1), { x: CLOUD_DRIFT[0].x, y: CLOUD_DRIFT[0].y, ease: 'none', scrollTrigger }),
      gsap.to(el(c3), { x: CLOUD_DRIFT[1].x, y: CLOUD_DRIFT[1].y, ease: 'none', scrollTrigger }),
      gsap.to(el(c4), { x: CLOUD_DRIFT[2].x, y: CLOUD_DRIFT[2].y, ease: 'none', scrollTrigger }),
      gsap.to(el(c5Wrap), { x: CLOUD_DRIFT[3].x, y: CLOUD_DRIFT[3].y, ease: 'none', scrollTrigger }),
    ];

    const refresh = () => ScrollTrigger.refresh();
    refresh();
    const rafId = requestAnimationFrame(refresh);
    window.addEventListener('load', refresh);

    return () => {
      window.removeEventListener('load', refresh);
      cancelAnimationFrame(rafId);
      animations.forEach((animation) => {
        if (animation.scrollTrigger) animation.scrollTrigger.kill();
        animation.kill();
      });
    };
  }, []);

  return (
    <section ref={sectionRef} className={styles.advantages}>
      <div className={styles['advantages__clouds']} aria-hidden>
        <img ref={c1} src={cloud} alt="" className={styles['advantages__cloud-1']} />
        <img ref={c3} src={cloud} alt="" className={styles['advantages__cloud-3']} />
        <img ref={c4} src={cloud2} alt="" className={styles['advantages__cloud-4']} />
        <span ref={c5Wrap} className={styles['advantages__cloud-5-outer']}>
          <span className={styles['advantages__cloud-5-inner']}>
            <img src={cloud2} alt="" className={styles['advantages__cloud-5']} />
          </span>
        </span>
      </div>
      <div className={styles.advantages__content}>
        <div className={styles.advantages__logo}>
          <img src={logo} alt="Причал" />
        </div>
        {advantagesContent.list.map((item) => (
          <div key={item} className={styles.advantages__item}>
            <p dangerouslySetInnerHTML={{ __html: item }} />
          </div>
        ))}
      </div>
    </section>
  );
}
